"use client";

import './compact-step-indicator-item.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import Text from '../../typography/text/index.js';
import CheckmarkBold from '../../icons/component-icons/checkmark-bold/index.js';
import styles from './compact-step-indicator-item.module.scss.js';

const CompactStepIndicatorItem = (props) => {
    const { surface = 'lightPrimary', status, readonly = false, label, eyebrow, hideTrack = false, orientation = 'horizontal', selected = false, minHeight = '44px', onClick } = props, rest = __rest(props, ["surface", "status", "readonly", "label", "eyebrow", "hideTrack", "orientation", "selected", "minHeight", "onClick"]);
    const progressBarStyles = [styles.progressBar];
    const iconWrapperStyles = [styles.iconWrapper];
    const titleWrapperStyles = [styles.titleWrapper];
    const lableWrapperStyles = [styles.labelWrapper];
    const indicatorStyles = [styles.titleIndicator];
    const progressBarContainer = [styles.titleProgressBarContainer];
    const [isHover, setIsHovered] = useState(false);
    const [keyPressed, setKeyPressed] = useState(false);
    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    const handleKeyDown = (event) => {
        if ((event.key === 'Enter' || event.key === ' ') && !keyPressed) {
            setKeyPressed(true);
            if (onClick)
                onClick(event);
        }
    };
    const handleKeyUp = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            setKeyPressed(false);
        }
    };
    if (!status || readonly) {
        lableWrapperStyles.push(styles.readonly);
    }
    if (surface === 'lightBrandNeutral') {
        iconWrapperStyles.push(styles.lightBrandNeutral);
        progressBarStyles.push(styles.lightBrandNeutral);
        lableWrapperStyles.push(styles.lightBrandNeutral);
    }
    if (status === 'complete' && !selected && !readonly) {
        iconWrapperStyles.push(styles.green);
        progressBarStyles.push(styles.green);
    }
    if (status === 'complete' && selected && !readonly) {
        iconWrapperStyles.push(styles.selected);
        iconWrapperStyles.push(styles.green);
    }
    if (orientation === 'vertical') {
        titleWrapperStyles.push(styles.vertical);
        progressBarStyles.push(styles.vertical);
        lableWrapperStyles.push(styles.vertical);
        indicatorStyles.push(styles.vertical);
        progressBarContainer.push(styles.vertical);
    }
    if ((label === null || label === void 0 ? void 0 : label.showBottomPadding) === true && orientation !== 'horizontal') {
        lableWrapperStyles.push(styles.showBottomPadding);
    }
    if (selected && !readonly) {
        lableWrapperStyles.push(styles.selected);
        if (status !== 'complete') {
            iconWrapperStyles.push(styles.selected);
        }
    }
    if (keyPressed && !readonly) {
        iconWrapperStyles.push(styles.keyDown);
    }
    if (isHover && !readonly) {
        iconWrapperStyles.push(styles.hover);
        lableWrapperStyles.push(styles.hover);
    }
    const _onClick = (event) => {
        if (!readonly && !selected && onClick)
            onClick(event);
    };
    return (jsxs("div", Object.assign({}, rest, { style: { minHeight: orientation === 'vertical' ? minHeight : undefined }, className: titleWrapperStyles.join(' '), children: [(label === null || label === void 0 ? void 0 : label.position) === 'top' && orientation === 'horizontal' && (jsxs("div", { className: lableWrapperStyles.join(' '), onClick: _onClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [eyebrow && (jsx(Text, Object.assign({ kind: "micro", bold: selected && !readonly }, eyebrow))), jsx(Text, Object.assign({ size: "small", kind: "body", bold: selected && !readonly }, label))] })), jsxs("div", { className: indicatorStyles.join(' '), children: [jsx("div", { className: iconWrapperStyles.join(' '), onClick: _onClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, tabIndex: 0, role: "button", "aria-label": "step indicator", "data-testid": "compact-indicator-button", children: jsx(CheckmarkBold, { size: "12px", color: "var(--vds-color-element-primary-ondarkprimary)" }) }), jsx("div", { className: progressBarContainer.join(' '), children: !hideTrack && (jsx("div", { className: progressBarStyles.join(' '), children: jsx("div", { className: "bar-overlay" }) })) })] }), ((label === null || label === void 0 ? void 0 : label.position) !== 'top' || orientation === 'vertical') && (jsxs("div", { className: lableWrapperStyles.join(' '), onClick: _onClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [eyebrow && (jsx(Text, Object.assign({ kind: "micro", bold: selected && !readonly }, eyebrow))), jsx(Text, Object.assign({ size: "small", kind: "body", bold: selected && !readonly }, label))] }))] })));
};

export { CompactStepIndicatorItem as default };
